import React, { Component } from "react";

class ContactOne extends Component{
    constructor(props){
        super(props);
        this.state = {
            rnName: '',
            rnEmail: '',
            rnSubject: '',
            rnPhone: '',
            rnMessage: '',
        };
    }
    render(){
        return(
            <div className="contact-form--1">
                <div className="container">
                <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                <h2 className="title">Don’t hesitate to contact us for inquires!</h2>
                                <p>We are a Digital Marketing company that provides brands with the digital identity they require. We’ll integrate digital services into your brand for optimum visibility, customer reach and brand recall. </p>
                            </div>
                        </div>
                    </div>
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--50">
                                {/* <h2 className="title">Get in Touch Today!</h2>
                                <p className="description"></p> */}
                            </div>
                            <div className="form-wrapper">

                                <form action="https://digitoze.com/email.php" method="POST">
                                    <label htmlFor="item01">
                                        <input
                                            type="text"
                                            name="name"
                                            id="item01"
                                            value={this.state.rnName}
                                            onChange={(e)=>{this.setState({rnName: e.target.value});}}
                                            placeholder="Your Name *"
                                        />
                                    </label>

                                    <label htmlFor="item02">
                                        <input
                                            type="text"
                                            name="email"
                                            id="item02"
                                            value={this.state.rnEmail}
                                            onChange={(e)=>{this.setState({rnEmail: e.target.value});}}
                                            placeholder="Your Email *"
                                        />
                                    </label>

                                    <label htmlFor="item05">
                                        <input
                                            type="number"
                                            name="phone"
                                            id="item05"
                                            value={this.state.rnPhone}
                                            onChange={(e)=>{this.setState({rnPhone: e.target.value});}}
                                            placeholder="Enter Phone Number*"
                                        />
                                    </label>
                                    <label htmlFor="item03">
                                        <input
                                            type="text"
                                            name="subject"
                                            id="item03"
                                            value={this.state.rnSubject}
                                            onChange={(e)=>{this.setState({rnSubject: e.target.value});}}
                                            placeholder="Write a Subject"
                                        />
                                    </label>
                                    <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label>
                                    <button className="rn-button-style--2 btn-solid" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">Submit</button>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src="/assets/images/about/about-6.webp" alt="Digitoze"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactOne;